const routes = [
  {
    path: "/",
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: "/",
        redirect: "/home",
      },
      { path: "home", component: () => import("@/pages/home/Home.vue") },
      {
        path: "map/:flight_id?",
        name: "map",
        component: () => import("@/pages/flight/map/Map.vue"),
      },
      {
        path: "legal",
        component: () => import("@/pages/legal/LegalDocuments.vue"),
      },
      {
        path: "roadmap",
        component: () => import("@/pages/development/Roadmap.vue"),
      },
    ],
  },
  {
    path: "/",
    meta: { requiresAuth: true },
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: "airlines",
        component: () => import("@/pages/airline/Search.vue"),
      },
    ],
  },
  {
    path: "/pilot",
    meta: { requiresAuth: true },
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: ":pilot_id",
        component: () => import("@/pages/pilot/profile/Profile.vue"),
      },
      {
        path: "inbox/:participant_id?/:conversation_id?",
        name: "chatInbox",
        component: () => import("@/pages/pilot/inbox/inbox.vue"),
      },
      {
        path: "airlines",
        component: () => import("@/pages/pilot/airlines/MyAirlines.vue"),
      },
      {
        path: "settings/:tab?",
        component: () => import("@/pages/pilot/account/Settings.vue"),
      },
      {
        path: "flights",
        component: () => import("@/pages/pilot/flights/MyFlights.vue"),
      },
      {
        path: "flights/add",
        component: () => import("@/pages/pilot/flights/AddFlight.vue"),
      },
      {
        path: "awards",
        component: () => import("@/pages/pilot/awards/MyAwards.vue"),
      },
      {
        path: "logger",
        component: () => import("@/pages/flight/logger/Logger.vue"),
      },
      {
        path: "billing",
        component: () => import("@/pages/subscriptions/Billing.vue"),
      },
    ],
  },
  {
    path: "/pilot",
    meta: { requiresNoAuth: true },
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: "register",
        component: () => import("@/pages/pilot/account/Register.vue"),
      },
      {
        path: "login",
        component: () => import("@/pages/pilot/account/Login.vue"),
      },
    ],
  },
  {
    path: "/pilot",
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: "confirm/:token",
        component: () => import("@/pages/pilot/account/EmailConfirm.vue"),
      },
      {
        path: "reset/:token?",
        component: () => import("@/pages/pilot/account/ResetPassword.vue"),
      },
      {
        path: "sso/:result?",
        component: () => import("@/pages/pilot/account/SSO.vue"),
      },
    ],
  },
  {
    path: "/airline",
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: ":airline_id",
        component: () => import("@/pages/airline/page/AirlinePage.vue"),
        children: [
          {
            name: "airlineInfo",
            path: "info",
            component: () => import("@/pages/airline/page/tabs/info.vue"),
          },
          {
            name: "airlineStatute",
            path: "statute",
            component: () => import("@/pages/airline/page/tabs/statute.vue"),
          },
          {
            name: "airlineFeed",
            path: "feed",
            component: () => import("@/pages/airline/page/tabs/feed.vue"),
          },
          { path: "", redirect: { name: "airlineInfo" } },
          {
            path: "awards",
            component: () => import("@/pages/airline/page/tabs/awards.vue"),
          },
          {
            path: "pilots",
            component: () => import("@/pages/airline/page/tabs/pilots.vue"),
          },
          {
            path: "aircraft",
            component: () => import("@/pages/airline/page/tabs/fleet.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/airline",
    meta: { requiresAuth: true },
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: ":airline_id/join",
        component: () => import("@/pages/airline/AirlineJoin.vue"),
      },
      {
        path: ":airline_id",
        component: () => import("@/pages/airline/page/AirlinePage.vue"),
        children: [
          {
            path: "operations",
            component: () => import("@/pages/airline/page/tabs/operations.vue"),
          },
          {
            path: "flights",
            component: () => import("@/pages/airline/page/tabs/flights.vue"),
          },
        ],
      },
      {
        path: ":airline_id/manage",
        component: () => import("@/pages/airline/manage/Manage.vue"),
        children: [
          {
            name: "manageDashboard",
            path: "dashboard",
            component: () =>
              import("@/pages/airline/manage/tabs/managerDashboard.vue"),
          },
          { path: "", redirect: { name: "manageDashboard" } },
          {
            path: "info",
            component: () =>
              import("@/pages/airline/manage/tabs/managerInfo.vue"),
          },
          {
            path: "general",
            component: () =>
              import("@/pages/airline/manage/tabs/managerGeneral.vue"),
          },
          {
            path: "feed",
            component: () =>
              import("@/pages/airline/manage/tabs/managerFeed.vue"),
          },
          {
            path: "awards",
            component: () =>
              import("@/pages/airline/manage/tabs/managerAwards.vue"),
          },
          {
            path: "awards/:award_id",
            component: () =>
              import("@/pages/airline/manage/dialogs/awards/AwardDetails.vue"),
          },
          {
            path: "pilots/:status?",
            name: "airline-pilots",
            component: () =>
              import("@/pages/airline/manage/tabs/managerPilots.vue"),
          },
          {
            path: "pilot/:pilot_id",
            component: () =>
              import("@/pages/airline/manage/dialogs/pilot/PilotDetails.vue"),
          },
          {
            path: "airports",
            component: () =>
              import("@/pages/airline/manage/tabs/managerAirports.vue"),
          },
          {
            path: "airports/:icao",
            component: () =>
              import("@/pages/airline/manage/dialogs/airport/AirportDetails.vue"),
          },
          {
            path: "aircraft",
            component: () =>
              import("@/pages/airline/manage/tabs/managerFleet.vue"),
          },
          {
            path: "aircraft/:aircraft_id",
            component: () =>
              import("@/pages/airline/manage/dialogs/aircraft/AircraftDetails.vue"),
          },
          {
            path: "schedules",
            component: () =>
              import("@/pages/airline/manage/tabs/managerSchedules.vue"),
          },
          {
            path: "schedules/:schedule_id",
            component: () =>
              import("@/pages/airline/manage/dialogs/schedule/ScheduleDetails.vue"),
          },
          {
            path: "flights",
            component: () =>
              import("@/pages/airline/manage/tabs/managerFlights.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/airline/public",
    component: () => import("@/layouts/EmbedLayout.vue"),
    children: [
      {
        path: "map",
        component: () => import("@/pages/airline/embeds/AirlineMap.vue"),
      },
    ],
  },
  {
    path: "/award",
    meta: { requiresAuth: true },
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: ":award_id",
        component: () => import("@/pages/award/Award.vue"),
      },
    ],
  },
  {
    path: "/flight",
    meta: { requiresAuth: true },
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: ":flight_id",
        component: () => import("@/pages/flight/review/Review.vue"),
      },
    ],
  },
  {
    path: "/airport",
    meta: { requiresAuth: true },
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: ":icao",
        component: () => import("@/pages/airport/Airport.vue"),
      },
    ],
  },
];

if (import.meta.env.QUASAR_MODE === "electron") {
  console.debug("Add overlay route");
  routes.push({
    path: "/overlay",
    component: () => import("@/layouts/Overlay.vue"),
  });
}

// Always leave this as last one,
// but you can also remove it
routes.push({
  path: "/:catchAll(.*)*",
  component: () => import("@/pages/Error404.vue"),
});

export default routes;
